import { cx } from '@linaria/core';
import { Tooltip, CircularButton } from '@ui/kit';
import { ChevronIcon, ExternalLinkIcon, OpenIcon, DownloadIcon } from '@ui/kit/icons';
import { buttonWrapper, chevron } from './atom.button.style.js';
import { jsx } from 'react/jsx-runtime';

function CardButton(props) {
  return /*#__PURE__*/jsx("div", {
    className: cx(buttonWrapper, props.className),
    children: /*#__PURE__*/jsx(Content, {
      ...props
    })
  });
}
function Content(props) {
  switch (props.icon) {
    case "download":
      return /*#__PURE__*/jsx(Tooltip, {
        placement: "right",
        body: `Download ${props.title}`,
        ariaType: "label",
        children: ref => /*#__PURE__*/jsx(CircularButton, {
          as: "a",
          ref: ref,
          icon: /*#__PURE__*/jsx(DownloadIcon, {}),
          size: "large",
          theme: props.theme,
          href: props.href,
          download: true,
          "data-link-trigger": true
        })
      });
    case "lightbox":
      return /*#__PURE__*/jsx(Tooltip, {
        placement: "right",
        body: `Åbn ${props.title} i lightbox`,
        ariaType: "label",
        children: ref => /*#__PURE__*/jsx(CircularButton, {
          as: "a",
          ref: ref,
          icon: /*#__PURE__*/jsx(OpenIcon, {}),
          size: "large",
          theme: props.theme,
          href: props.href,
          target: "_lightbox",
          "data-link-trigger": true
        })
      });
    case "new-tab":
      return /*#__PURE__*/jsx(Tooltip, {
        placement: "right",
        body: `Gå til ${props.title} i nyt vindue`,
        ariaType: "label",
        children: ref => /*#__PURE__*/jsx(CircularButton, {
          as: "a",
          ref: ref,
          icon: /*#__PURE__*/jsx(ExternalLinkIcon, {}),
          size: "large",
          theme: props.theme,
          href: props.href,
          target: "_blank",
          "data-link-trigger": true
        })
      });
    case "same-tab":
      return /*#__PURE__*/jsx(Tooltip, {
        placement: "right",
        body: `Gå til ${props.title}`,
        ariaType: "label",
        children: ref => /*#__PURE__*/jsx(CircularButton, {
          ref: ref,
          as: "a",
          icon: /*#__PURE__*/jsx(ChevronIcon, {
            className: chevron
          }),
          size: "large",
          theme: props.theme,
          href: props.href,
          "data-link-trigger": true
        })
      });
    default:
      return null;
  }
}

export { CardButton };
//# sourceMappingURL=atom.button.js.map
